class AddToCart {
    constructor() {
        this.addEventListener();
    }
    addEventListener() {
        document.querySelectorAll('addtocart:not([data-listener="true"])').forEach((t) => {
            t.setAttribute("data-listener", !0),
                t.addEventListener("click", (t) => {
                    this.handleAddToCart(t.currentTarget);
                });
        });
    }
    handleAddToCart(t) {
        let e;
        if (t.classList.contains("button--instant-buy")) {
            const s = t.dataset.quantity || 5;
            e = { quantity: Number(s), id: t.dataset.variantid };
        } else {
            let s = t.parentElement.querySelector(".card-product--popup-pack.selected");
            if (!s) return;
            e = { quantity: Number(s.dataset.quantity), id: t.dataset.variantid };
        }
        this.incrementCartNumber(e.quantity), this.showLoadingState(t), this.addToCart(e, t);
    }
    async addToCart(t, e) {
        try {
            const s = await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(t),
            });
            if (s.ok) {
                await s.json();
                this.showSuccessState(e);

                // Refresh cart drawer if it exists
            if (window.cartDrawer && typeof window.cartDrawer.loadDetails === 'function') {
                await window.cartDrawer.loadDetails();
            }

            if (window.drawerController && typeof window.drawerController.openDrawer === "function") {
                window.drawerController.openDrawer("cart");
            }

            } else console.error("Failed to add to cart:", s.status), this.resetButtonState(e);
        } catch (t) {
            console.error("Error adding to cart:", t), this.resetButtonState(e);
        }
    }
    showLoadingState(t) {
        t.classList.add("button--loading");
    }
    showSuccessState(t) {
        t.querySelector(".spinner").classList.add("load-complete"),
            setTimeout(() => {
                this.resetButtonState(t);
            }, 700);
    }
    resetButtonState(t) {
        t.querySelector(".spinner").classList.remove("load-complete"),
            t.classList.remove("button--loading");

        const popup = t.closest(".card-product--popup");
        if (popup) {
            popup.classList.remove("active");
        }

        if (window.drawerController && window.drawerController.body) {
            window.drawerController.body.classList.remove("open-product");
            if (!window.drawerController.body.classList.contains("open-cart")) {
                window.drawerController.body.classList.remove("no-scroll");
            }
        }
    }
    incrementCartNumber(t) {
        document.querySelectorAll(".cart-num").forEach((e) => {
            let s = parseInt(e.innerHTML, 10) || 0;
            e.innerHTML = `${s + t}`;
        }),
            document.querySelectorAll(".header--icon-cart").forEach((t) => {
                t.classList.add("active-cart");
            });
    }
}
const addToCart = new AddToCart();
class CardProduct {
    constructor() {
        this.addEventListener(),
            (this.formatCurrency = new Intl.NumberFormat("en-US", { style: "currency", currency: "GBP" })),
            (this.productCard = null),
            (this.productCardImage = null),
            (this.popupCard = null),
            (this.inputQuantity = null),
            (this.addToCartButton = null),
            (this.totalPoints = null),
            (this.totalSavings = null),
            (this.price = null),
            (this.quantity = null),
            (this.pointsMultiplier = null),
            (this.originalPrice = null),
            (this.compareAtPrice = null),
            (this.popupImage = null),
            this.updateInitialStrengthDisplay();
    }
    addEventListener() {
        document.querySelectorAll(".card-product--popup-pack, .quick-buy--adjust").forEach((t) => {
            t.setAttribute("data-listener", !0),
                t.addEventListener("click", (t) => {
                    this.updateQuantity(t.currentTarget);
                });
        }),
            document.querySelectorAll(".select-title--container").forEach((t) => {
                t.setAttribute("data-listener", !0),
                    t.addEventListener("click", (t) => {
                        t.currentTarget.closest(".card-product--popup-strength-select").classList.toggle("active");
                    });
            }),
            document.querySelectorAll(".select-option").forEach((t) => {
                t.setAttribute("data-listener", !0),
                    t.addEventListener("click", (t) => {
                        this.selectVariant(t.currentTarget);
                    });
            }),
            document.querySelectorAll(".card-product--variants-title").forEach((t) => {
                t.setAttribute("data-listener", !0),
                    t.addEventListener("click", (t) => {
                        this.selectVariantTitle(t.currentTarget);
                    });
            }),
            document.querySelectorAll(".card-product").forEach((t) => {
                const e =
                    t.querySelector(".card-product--variants-title.selected") ||
                    t.querySelector(".select-option.selected");
                this.updateStrengthDisplay(t, e);
            });
    }
    updateInitialStrengthDisplay() {
        document.querySelectorAll(".card-product--popup-inner").forEach((t) => {
            const e = t.querySelector(".select-title--container"),
                s = t.closest(".product--right");
            if (!s || !e) return;
            const a = s.querySelectorAll(".card-product--mg-pp"),
                r = e.dataset.varpouchstrength;
            r &&
                a.length > 0 &&
                a.forEach((t) => {
                    t.innerHTML = `${r}<span class="mg">MG</span>`;
                });
        });
    }
    updateStrengthDisplay(t, e) {
        if (!e) return;
        const s = e.dataset.varpouchstrength;
        t.querySelectorAll(".card-product--mg-pp").forEach((t) => {
            t.innerHTML = `${s}<span class="mg">MG</span>`;
        });
    }
    updateQuantity(t) {
        (this.popupCard = t.closest(".card-product--popup-inner")),
            (this.inputQuantity = this.popupCard.querySelector(".quick-buy--quantity")),
            (this.addToCartButton = this.popupCard.querySelector("addtocart .button--text")),
            (this.totalPoints = this.popupCard.querySelector(".total-points-earned--value")),
            (this.totalSavings = this.popupCard.querySelector(".pack-saving")),
            "pack" === t.dataset.type ? this.updateQuantityPack(t) : this.updateQuantityQuickbuy(t),
            this.updatePopupCard();
    }
    updateQuantityPack(t) {
        (this.price = t.dataset.price),
            (this.quantity = t.dataset.quantity),
            (this.pointsMultiplier = t.dataset.multiplier),
            (this.originalPrice = t.dataset.original),
            (this.compareAtPrice = t.dataset.compareatprice ? parseInt(t.dataset.compareatprice, 10) : null),
            this.popupCard.querySelectorAll(".card-product--popup-pack").forEach((e) => {
                e !== t.closest(".card-product--popup-pack")
                    ? e.classList.remove("selected")
                    : e.classList.add("selected");
            }),
            (this.addToCartButton.closest("addtocart").dataset.quantity = this.quantity),
            this.popupCard
                .querySelector(".quick-buy--minus")
                .classList.toggle("disabled", 1 === parseInt(this.quantity));
    }
    updateQuantityQuickbuy(t) {
        const e = this.inputQuantity.value.replace(/\s+/g, "");
        let s;
        t.classList.contains("quick-buy--plus")
            ? this.inputQuantity.setAttribute("value", parseInt(e) + 1)
            : this.inputQuantity.setAttribute("value", parseInt(e) - 1),
            (s = parseInt(this.inputQuantity.value.replace(/\s+/g, ""), 10)),
            (this.addToCartButton.closest("addtocart").dataset.quantity = s),
            this.popupCard.querySelector(".quick-buy--minus").classList.toggle("disabled", 1 === parseInt(s));
        let a = [...this.popupCard.querySelectorAll(".card-product--popup-pack")].map((t) => ({
            item: t,
            quantity: parseInt(t.dataset.quantity),
            price: parseInt(t.dataset.price),
            pointsMultiplier: parseFloat(t.dataset.multiplier),
            originalPrice: parseInt(t.dataset.original),
            compareAtPrice: t.dataset.compareat ? parseInt(t.dataset.compareat, 10) : null,
        }));
        a = a.sort((t, e) => e.quantity - t.quantity);
        let r = !1;
        for (const t of a)
            !r && s >= t.quantity
                ? (t.item.classList.add("selected"),
                  (this.pointsMultiplier = t.pointsMultiplier),
                  (this.price = t.price),
                  (this.originalPrice = t.originalPrice),
                  (this.compareAtPrice = t.compareAtPrice),
                  (r = !0))
                : t.item.classList.remove("selected");
        this.quantity = this.inputQuantity.value.replace(/\s+/g, "");
    }
    selectVariant(t) {
        (this.productCard = t.closest(".card-product") || t.closest(".product--container")),
            (this.popupCard = t.closest(".card-product--popup-inner")),
            (this.addToCartButton = this.popupCard.querySelector("addtocart")),
            (this.productCardImage = this.productCard.classList.contains("card-product")
                ? this.productCard.querySelectorAll(".card-product--image img")
                : this.productCard.querySelectorAll(".product--image img")),
            t.classList.contains("oos")
                ? console.log("oos")
                : (this.popupCard.querySelector(".card-product--popup-strength-select").classList.remove("active"),
                  (this.popupCard.querySelector(".select--option-title").innerHTML = t.dataset.title),
                  this.addToCartButton.setAttribute("data-variantid", t.dataset.variantid),
                  this.productCard.querySelectorAll(".card-product--variants-title").forEach((e) => {
                      e.dataset.variantid === t.dataset.variantid
                          ? e.classList.add("selected")
                          : e.classList.remove("selected");
                  }),
                  this.productCardImage?.forEach((e) => {
                      e.setAttribute("srcset", t.dataset.image), e.setAttribute("src", t.dataset.image);
                  }));
        const e = this.productCard.querySelectorAll(".product--content .card-product--mg-pp"),
            s = t.dataset.varpouchstrength;
        e.length > 0 &&
            s &&
            e.forEach((t) => {
                t.innerHTML = `${s}<span class="mg">MG</span>`;
            });
    }
    selectVariantTitle(t) {
        if (
            ((this.productCard = t.closest(".card-product")),
            (this.popupCard = this.productCard.querySelector(".card-product--popup-inner")),
            (this.addToCartButton = this.popupCard.querySelector("addtocart")),
            (this.productCardImage = this.productCard.querySelectorAll(".card-product--image img")),
            (this.productCardMgDisplay = this.productCard.querySelectorAll(".card-product--mg-pp")),
            t.classList.contains("oos"))
        )
            return;
        const e = new Image();
        this.productCard.classList.add("loading"),
            (e.onload = () => {
                this.productCardImage.forEach((e) => {
                    e.setAttribute("srcset", t.dataset.image), e.setAttribute("src", t.dataset.image);
                }),
                    this.productCard.classList.remove("loading");
            }),
            (e.src = t.dataset.image),
            this.productCard.querySelectorAll(".card-product--variants-title").forEach((t) => {
                t.classList.remove("selected");
            }),
            this.popupCard.querySelector(".card-product--popup-strength-select").classList.remove("active"),
            (this.popupCard.querySelector(".select--option-title").innerHTML = t.dataset.title),
            t.classList.add("selected"),
            this.addToCartButton.setAttribute("data-variantid", t.dataset.variantid);
        const s = t.dataset.varpouchstrength;
        this.productCardMgDisplay.length > 0 &&
            this.productCardMgDisplay.forEach((t) => {
                t.innerHTML = `${s}<span class="mg">MG</span>`;
            });
    }
    updatePopupCard() {
        const quantity = Number(this.quantity.replace(/\s+/g, ""));
        const price = Number(this.price);
        const pointsMultiplier = Number(this.pointsMultiplier || 0);
        const originalPrice = Number(null !== this.compareAtPrice ? this.compareAtPrice : this.originalPrice);
        const points = Math.round(price * quantity * pointsMultiplier);
        const total = (price * quantity) / 100;
        const savings = ((originalPrice - price) * quantity) / 100;

        this.inputQuantity.setAttribute("value", quantity),
            (this.addToCartButton.innerHTML = `Add to cart | ${this.formatCurrency.format(total)}`),
            (this.totalPoints.innerHTML = `${points}`),
            this.addToCartButton.closest("addtocart").setAttribute("data-packpoints", points);

        this.totalSavings.textContent = this.formatCurrency.format(Math.max(0, savings));
    }
}
const cardProduct = new CardProduct();
class CartDrawer {
    constructor() {
        this.cartContainer = document.querySelector(".cart-drawer--main");
        this.promoAddToCart = document.querySelector(".promotion-button--instant-buy");
        this.claimContainers = Array.from(document.querySelectorAll("[data-cart-claim-prize]"));
        this.claimPopup = document.querySelector("[data-claim-popup]");
        
        // Check if cart elements exist before initializing
        if (!this.cartContainer) {
            console.log('Cart drawer not found on this page');
            return; // Exit if cart drawer doesn't exist
        }

        // Only add event listeners if elements exist
        this.cartContainer.addEventListener("click", this.handleCartActions.bind(this));
        
        if (this.promoAddToCart) {
            this.promoAddToCart.addEventListener("click", (t) => {
                this.handleCartActions(t);
            });
        }

        this.claimContainers.forEach((t) => {
            t.addEventListener("click", this.handleClaimActions.bind(this));
        });

        if (this.claimPopup) {
            this.claimPopup.addEventListener("click", this.handleClaimActions.bind(this));
        }
        
        this.loadDetails();
    }

    async loadDetails() {
    // Check if cartContainer exists before making API call
    if (!this.cartContainer) return;
    
    try {
        // Use the standard Shopify cart.js endpoint
        const response = await fetch("/cart.js");
        
        // Check if response is successful
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const cartData = await response.json();
        this.displayCartDetails(cartData);
    } catch (error) {
        console.error("Error fetching cart details:", error);
        // Optional: Show user-friendly error message
        this.cartContainer.innerHTML = '<p>Unable to load cart items</p>';
    }
}

    updateDiscountMessage(t) {
        const e = t.item_count,
            s = Array.from(document.querySelectorAll(".summary-tier"))
                .map((t) => ({
                    quantity: parseInt(t.textContent.trim(), 10),
                    discount: `${t.dataset.packpercent}%`,
                    discountRaw: t.dataset.packpercent,
                }))
                .filter((t) => !Number.isNaN(t.quantity) && t.discountRaw)
                .sort((t, e) => t.quantity - e.quantity),
            a = s.find((t) => t.quantity > e),
            r = [...s].reverse().find((t) => e >= t.quantity),
            n = document.querySelector(".summary-info"),
            o = document.querySelectorAll(".summary-progress-bar"),
            c = document.querySelectorAll(".summary-tier");
            
        if (!n) return;
        
        if ((this.messageTimeout && clearTimeout(this.messageTimeout), a))
            if (r && e === r.quantity)
                (n.innerHTML = `<strong>${r.discount} Off unlocked!</strong>`),
                    (this.messageTimeout = setTimeout(() => {
                        const t = a.quantity - e;
                        n.innerHTML = `Add <span class="item-amount">${t}</span> more for <span class="discount-tier">${a.discount}</span> Off!`;
                    }, 2e3));
            else {
                const t = a.quantity - e;
                n.innerHTML = `Add <span class="item-amount">${t}</span> more for <span class="discount-tier">${a.discount}</span> Off!`;
            }
        else n.innerHTML = `<strong>Maximum ${r ? r.discount : "0%"} discount unlocked!</strong>`;
        
        o.forEach((t, a) => {
            const r = parseInt(t.dataset.progress, 10),
                i = a > 0 ? s[a - 1].quantity : 0,
                n = r - i,
                o = Math.max(0, Math.min(1, (e - i) / n));
            t.classList.remove("active"),
                t.style.setProperty("--fill", "0%"),
                e >= r
                    ? (t.classList.add("active"),
                      t.style.setProperty("--fill", "100%"),
                      c[a] && c[a].classList.add("active"))
                    : e > i && e < r
                      ? (t.classList.add("active"),
                        t.style.setProperty("--fill", 100 * o + "%"),
                        c[a] && c[a].classList.remove("active"))
                      : c[a] && c[a].classList.remove("active");
        });
        
        document.querySelectorAll(".summary-percentage-block").forEach((t) => {
            t.classList.remove("active");
        }),
        
        s.forEach((t) => {
            if (e >= t.quantity) {
                const s = document.querySelector(`.summary-percentage-block[data-percent="${t.discountRaw}"]`);
                if (s) {
                    s.classList.add("active");
                }
            }
        });
    }

    displayCartDetails(t) {
        // Check if cartContainer exists before updating
        if (!this.cartContainer) return;
        
        let e = new Intl.NumberFormat("en-US", { style: "currency", currency: "GBP" });
        this.cartContainer.innerHTML = "";
        let s = t.item_count,
            a = t.items_subtotal_price / 100;
            
        document.querySelectorAll(".cart-num").forEach((t) => {
            t.innerHTML = `${s}`;
        });
        
        let r = 0;
        t.items.forEach((t) => {
            if (t.compare_at_price && t.compare_at_price > t.final_price) {
                const e = (t.compare_at_price - t.final_price) * t.quantity;
                r += e;
            }
        });
        
        const i = (t.total_discount + r) / 100,
            n = t.items.reduce((e, t) => e + Math.round(t.final_price * t.quantity * 0.02), 0),
            o = t.total_price / 100;
        document.querySelectorAll(".cart--savings").forEach((t) => {
            t.textContent = e.format(i);
        }),
        document.querySelectorAll(".cart--pts").forEach((t) => {
            t.textContent = `${n.toLocaleString()}pts`;
        }),
            
        document.querySelectorAll(".cart--total").forEach((t) => {
            t.textContent = e.format(o);
        });
        
        const c = document.querySelector(".summary-item.summary-shipping");
        if (c) {
            const t = c.querySelector(".summary-item.summary-shipping img");
            o >= 20
                ? (c.classList.remove("disabled"), t && (t.src = t.dataset.iconEnabled))
                : (c.classList.add("disabled"), t && (t.src = t.dataset.iconDisabled));
        }

        this.updateClaimOffer(t);
        
        this.updateDiscountMessage(t),
        
        t.items.forEach((s) => {
            let a = s.title.replace(s.vendor, "").trim();
            /Gold Edition/i.test(a) &&
                ((a = a.replace(/Gold Edition/gi, "").trim()), (s.vendor = `${s.vendor} Gold`)),
            (a = a
                .split(" - ")[0]
                .replace(/\s*\d+.*$/, "")
                .replace(/\(/g, "")
                .trim());
                
            let r = s.variant_title.match(/(\d+(\.\d+)?)\s*mg/i),
                i = r ? parseInt(r[1]) : null,
                n = "";
            null !== i &&
                (n =
                    i >= 0 && i <= 6
                        ? "Low"
                        : i >= 7 && i <= 11
                          ? "Medium"
                          : i >= 12 && i <= 20
                            ? "High"
                            : i >= 21 && i <= 40
                              ? "Strong"
                              : "Extra Strong");
                              
            let o = `${s.variant_title}`,
                c = s.tags?.find((t) => t.includes("label-offer--")),
                l = c ? c.replace("label-offer--", "") : "",
                d = c ? c.toLowerCase().replace(" ", "-").replace("& ", "") : "";
                
            const u = document.createElement("div");
            u.classList.add("cart-main--item"),
            (u.innerHTML = `\n        <span class="cart-main--item-image">\n          ${l ? `<span class="cart-main--label-offer ${d}">${l}</span>` : ""}\n          <img src="${s.image}" alt="${a}">\n        </span>\n        <span class="cart-main--item-info">\n          <span class="cart-main--item-content">\n            <span class="cart-main--item-vendor">${s.vendor} ${a}</span>\n            <span class="cart-main--item-strength">${o}</span>\n          </span>\n  \n          <div class="cart-main--item-action">\n            <span class="quick-buy--component">\n              <span class="quick-buy--adjust quick-buy--minus" data-line-item="${s.id}">\n                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2">\n                  <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">\n                </svg>\n              </span>\n              <input data-id="${s.variant_id}" type="number" value="${s.quantity}" class="quick-buy--quantity" disabled>\n              <span class="quick-buy--adjust quick-buy--plus" data-line-item="${s.id}">\n                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10">\n                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">\n                </svg>\n              </span>\n            </span>\n\n            <span class="cart-main--item-inner">\n              <span class="cart-main--item-price">\n                ${s.compare_at_price ? `<span class="cart-main--item-discount">${e.format(s.compare_at_price / 100)}</span>` : s.final_price < s.original_price ? `<span class="cart-main--item-discount">${e.format(s.original_price / 100)}</span>` : ""}\n                ${e.format(s.final_price / 100)}\n              </span>\n            \n              <span class="cart-main--item-delete" data-line-item="${s.id}">\n                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 15 16" fill="none">\n                  <path d="M5.625 2.375H9.375M1.875 4.25H13.125M11.875 4.25L11.4367 10.8246C11.3709 11.811 11.3381 12.3042 11.125 12.6781C10.9374 13.0074 10.6545 13.2721 10.3135 13.4373C9.92623 13.625 9.43193 13.625 8.44334 13.625H6.55666C5.56807 13.625 5.07377 13.625 4.68646 13.4373C4.34547 13.2721 4.06255 13.0074 3.87499 12.6781C3.66194 12.3042 3.62906 11.811 3.5633 10.8246L3.125 4.25M6.25 7.0625V10.1875M8.75 7.0625V10.1875" stroke="#004380" stroke-width="1.25641" stroke-linecap="round" stroke-linejoin="round"/>\n                </svg>\n              </span>\n            </span>\n          </div>\n        </span>\n      `),
            this.cartContainer.appendChild(u),
            this.hidePromoButtons(t);
        }),
        
        document.querySelectorAll(".header--icon-cart").forEach((e) => {
            0 == t.item_count && e.classList.contains("active-cart") && e.classList.remove("active-cart");
        });
    }

    handleCartActions(t) {
        const e = t.target;
        let s = 0,
            a = "";
        e.classList.contains("promotion-button--instant-buy") ||
            ((a = this.cartContainer
                .querySelector(`[data-line-item="${e.dataset.lineItem}"]`)
                .closest(".quick-buy--component")),
            (s = parseInt(a.querySelector(".quick-buy--quantity").value))),
        e.classList.contains("quick-buy--plus")
            ? (this.updateItemQuantity(e.dataset.lineItem, s + 1),
              document.querySelector(".cart-drawer--loading")?.classList.add("active"))
            : e.classList.contains("quick-buy--minus")
              ? (this.updateItemQuantity(e.dataset.lineItem, s - 1),
                document.querySelector(".cart-drawer--loading")?.classList.add("active"))
              : e.classList.contains("cart-main--item-delete")
                ? (this.deleteItem(e.dataset.lineItem),
                  document.querySelector(".cart-drawer--loading")?.classList.add("active"))
                : e.classList.contains("promotion-button--instant-buy") &&
                  (this.updateItemQuantity(e.dataset.variantid, 1),
                  document.querySelector(".cart-drawer--loading")?.classList.add("active"));
    }

    async updateItemQuantity(t, e) {
        if (e < 0) return;
        let s = { updates: { [t]: e } };
        try {
            const t = await fetch("/cart/update.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(s),
            });
            if (!t.ok) throw new Error(`HTTP error! Status: ${t.status}`);
            await t.json();
            this.loadDetails();
        } catch (t) {
            console.error("Error updating cart item:", t);
        }
        document.querySelector(".cart-drawer--loading")?.classList.remove("active");
    }

    async deleteItem(t) {
        try {
            await this.updateItemQuantity(t, 0);
        } catch (t) {
            console.error("Error deleting cart item:", t);
        }
    }

    hidePromoButtons(t) {
        const e = new Set(t.items.map((t) => t.variant_id)),
            s = document.querySelector(".promotion-button--instant-buy");
        if (!s) return;
        const a = parseInt(s.dataset.variantid, 10),
            r = document.querySelector(".cart-drawer--promo-product");
        r && (r.style.display = e.has(a) ? "none" : "block");
    }

    handleClaimActions(t) {
        const e = t.target.closest("[data-claim-open]"),
            s = t.target.closest("[data-claim-close]"),
            a = t.target.closest("[data-claim-add]"),
            r = t.target.closest("[data-claim-remove-all]");
        e && this.openClaimPopup();
        s && this.closeClaimPopup();
        a && this.addClaimProduct(a);
        r && this.removeAllClaimProducts();
    }

    openClaimPopup() {
        if (!this.claimPopup) return;
        this.claimPopup.removeAttribute("hidden");
        document.body.classList.add("open-popup", "no-scroll");
    }

    closeClaimPopup() {
        if (!this.claimPopup) return;
        this.claimPopup.setAttribute("hidden", "");
        document.body.classList.remove("open-popup", "no-scroll");
    }

    updateClaimOffer(t) {
        if (!this.claimContainers.length) return;
        const e = new Map();

        this.claimPopup?.querySelectorAll("[data-claim-product-card]").forEach((s) => {
            const a = Number(s.dataset.variantId),
                r = t.items.find((t) => t.variant_id === a)?.quantity || 0;
            e.set(a, r);
            const i = s.querySelector("[data-claim-product-qty]");
            i && (i.textContent = `${r}`);
        });

        const s = Array.from(e.values()).reduce((t, e) => t + e, 0),
            a = Math.max(0, t.item_count),
            r = Math.max(0, a - s);

        this.claimContainers.forEach((t) => {
            t.querySelector(".prize-eligblity")?.replaceChildren(document.createTextNode(`${a}`));
        });
        this.claimPopup?.querySelectorAll(".claim-limit-count").forEach((t) => {
            t.textContent = `${a}`;
        });
        this.claimPopup?.querySelector(".claim-selected-count")?.replaceChildren(document.createTextNode(`${s}`));

        this.claimPopup?.querySelectorAll("[data-claim-add]").forEach((t) => {
            t.disabled = r <= 0;
        });

        this.claimContainers.forEach((t) => {
            a >= 5 ? t.removeAttribute("hidden") : t.setAttribute("hidden", "");
        });

        if (a < 5) {
            this.closeClaimPopup();
        }
    }

    async addClaimProduct(t) {
        if (t.disabled) return;
        const e = Number(t.dataset.claimVariantid);
        if (!e) return;
        t.disabled = !0;
        document.querySelector(".cart-drawer--loading")?.classList.add("active");
        try {
            const t = await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: e, quantity: 1 }),
            });
            if (!t.ok) throw new Error(`HTTP error! Status: ${t.status}`);
            await t.json();
            this.loadDetails();
        } catch (t) {
            console.error("Error adding claim product:", t);
        }
        document.querySelector(".cart-drawer--loading")?.classList.remove("active");
    }

    async removeAllClaimProducts() {
        if (!this.claimPopup) return;
        const e = {};
        this.claimPopup.querySelectorAll("[data-claim-product-card]").forEach((t) => {
            const s = Number(t.dataset.variantId);
            s && (e[s] = 0);
        });
        if (0 === Object.keys(e).length) return;
        document.querySelector(".cart-drawer--loading")?.classList.add("active");
        try {
            const t = await fetch("/cart/update.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ updates: e }),
            });
            if (!t.ok) throw new Error(`HTTP error! Status: ${t.status}`);
            await t.json();
            this.loadDetails();
        } catch (t) {
            console.error("Error removing claim products:", t);
        }
        document.querySelector(".cart-drawer--loading")?.classList.remove("active");
    }
}

class CartPageMain {
    constructor() {
        this.container = document.querySelector(".cart-page-main");
        if (!this.container) return;
        this.isUpdating = !1;
        this.container.addEventListener("click", this.handleActions.bind(this));
    }

    handleActions(t) {
        const e = t.target.closest(".quick-buy--plus, .quick-buy--minus, .cart-main--item-delete");
        if (!e || this.isUpdating) return;
        const s = e.dataset.lineItem;
        if (!s) return;
        const a = e.closest(".cart-main--item"),
            r = parseInt(a?.querySelector(".quick-buy--quantity")?.value || "0", 10);
        let i = r;
        e.classList.contains("quick-buy--plus")
            ? i = r + 1
            : e.classList.contains("quick-buy--minus")
                ? i = Math.max(0, r - 1)
                : e.classList.contains("cart-main--item-delete") && (i = 0);
        this.updateItemQuantity(s, i);
    }

    async updateItemQuantity(t, e) {
        if (e < 0) return;
        this.isUpdating = !0;
        this.container.classList.add("is-updating");
        try {
            const s = await fetch("/cart/update.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ updates: { [t]: e } }),
            });
            if (!s.ok) throw new Error(`HTTP error! Status: ${s.status}`);
            await s.json();
            window.location.reload();
        } catch (t) {
            console.error("Error updating cart page item:", t);
            this.isUpdating = !1;
            this.container.classList.remove("is-updating");
        }
    }
}

// Fixed DrawerController with null checks
class DrawerController {
    constructor() {
        this.drawers = document.querySelectorAll(".drawer, .card-product--popup");
        this.popup = document.querySelector(".popup");
        this.body = document.body;
        
        // Check if required elements exist
        const overlay = document.getElementById("jsOverlay");
        if (!overlay) {
            console.log('Drawer overlay not found on this page');
            return;
        }
        
        this.eventListeners();
    }

    eventListeners() {
        document.querySelectorAll('.drawer-toggle').forEach((t) => {
            t.setAttribute("data-listener", "true");
            t.addEventListener("click", (e) => {
                const s = t.dataset.toggle;
                this.toggleDrawer(s, e.target), t.classList.toggle("active");
            });
        });

        document.getElementById("jsOverlay").addEventListener("click", this.closeActive.bind(this)),
        
        document.querySelectorAll(".drawer-close").forEach((t) => {
            t.addEventListener("click", this.closeActive.bind(this));
        });
    }

    async toggleDrawer(t, e) {
        const s = t.replace("Drawer", ""),
            a = `open-${s}`;
        if (this.body.classList.contains(a))
            this.body.classList.remove(a),
                this.body.classList.remove("no-scroll"),
                "search" === s && this.body.classList.remove("open-predictive");
        else {
            if (
                (this.removeDrawerAndPopupClasses(),
                this.body.classList.add(a),
                "cart" === s && typeof cartDrawer !== 'undefined' && cartDrawer.loadDetails,
                "search" === s)
            ) {
                const t = document.querySelector(".search-global--input");
                t && (
                    (t.style.display = "block"),
                    (t.style.pointerEvents = "auto"),
                    (t.style.visibility = "visible"),
                    t.focus()
                );
            }
            "product" === s &&
                e.parentElement.parentElement.querySelector(".card-product--popup")?.classList.toggle("active"),
                this.body.classList.add("no-scroll");
        }
    }

    openDrawer(t) {
        const drawerName = t.replace("Drawer", "");
        const bodyClass = `open-${drawerName}`;

        this.removeDrawerAndPopupClasses();
        this.body.classList.add(bodyClass);
        this.body.classList.add("no-scroll");
    }

    removeDrawerAndPopupClasses() {
    this.drawers.forEach((t) => {
        const e = t?.id ? t.id.replace("Drawer", "") : "product";
        this.body.classList.remove(`open-${e}`);
        
        // Fixed: Use if check instead of optional chaining in assignment
        if (!this.body.classList.contains("open-popup")) {
            const drawerPopup = document.querySelector("#drawerPopup");
            if (drawerPopup && !drawerPopup.hasAttribute("data-static-content")) {
                drawerPopup.innerHTML = "";
            }
        }
        
        if ("product" === e) {
            const productPopup = document.querySelector(".card-product--popup.active");
            if (productPopup) {
                productPopup.classList.remove("active");
            }
        }
        
        if ("search" === e) {
            this.body.classList.remove("open-predictive");
        }
    });
    
    this.body.classList.remove("open-popup");
    this.body.classList.remove("no-scroll");
}

    closeActive() {
        this.removeDrawerAndPopupClasses();
    }
}

// Initialize only if elements exist
document.addEventListener('DOMContentLoaded', function() {
    // Initialize CartDrawer only if cart drawer exists
    if (document.querySelector(".cart-drawer--main")) {
        const cartDrawer = new CartDrawer();
        window.cartDrawer = cartDrawer; // Make it globally available if needed
    }

    // Initialize DrawerController only if overlay exists
    if (document.getElementById("jsOverlay")) {
        const drawerController = new DrawerController();
        window.drawerController = drawerController; // Make it globally available if needed
    }

    window.addToCart = new AddToCart();

    if (document.querySelector(".cart-page-main")) {
        const cartPageMain = new CartPageMain();
        window.cartPageMain = cartPageMain;
    }

});
class MobileMenu {
    constructor() {
        // Check if mobile menu elements exist before initializing
        this.mobileMenuItems = document.querySelectorAll(".site-nav-main--menu-lv-1.site-nav-main--item.dropdown");
        
        if (this.mobileMenuItems.length === 0) {
            return; // Exit if no mobile menu items found
        }
        
        this.setEvents();
        this.setInitialMenuClass();
    }

    setEvents() {
        const t = (t, e, s = !1) => {
            const elements = document.querySelectorAll(t);
            if (elements.length === 0) return;
            
            elements.forEach((t) => {
                t.addEventListener("click", (t) => {
                    s && t.stopPropagation(), e(t);
                });
            });
        };

        // Only add event listeners if elements exist
        if (this.mobileMenuItems.length > 0) {
            t(".site-nav-main--menu-lv-1.site-nav-main--item.dropdown", this.openChild.bind(this));
        }

        const dropdownHeaders = document.querySelectorAll(".site-nav-main--dropdown-header");
        if (dropdownHeaders.length > 0) {
            t(".site-nav-main--dropdown-header", this.closeChild.bind(this));
        }

        const menuBlocks = document.querySelectorAll(".brands-menu--block, .strengths-menu--block, .deals-menu--block, .type-menu--block, .button-menu");
        if (menuBlocks.length > 0) {
            t(
                ".brands-menu--block, .strengths-menu--block, .deals-menu--block, .type-menu--block, .button-menu",
                () => {},
                !0
            );
        }

        const dropdownLinks = document.querySelectorAll(".dropdown-child-lv-2 > a");
        if (dropdownLinks.length > 0) {
            t(".dropdown-child-lv-2 > a", () => {}, !0);
        }
    }

    setInitialMenuClass() {
        this.mobileMenuItems.forEach((t) => {
            let e = t.getAttribute("data-mobliemenu");
            if (!e) return;
            
            e = e
                .toLowerCase()
                .replace(/&/g, "")
                .replace(/\s+/g, "-")
                .replace(/[^\w-]/g, "");
                
            const s = t.querySelector(".site-nav-main--menu-lv-2.dropdown-child");
            s && !s.classList.contains(e) && s.classList.add(e);
        });
    }

    openChild(t) {
        const e = t.currentTarget,
            s = e.querySelector(".site-nav-main--menu.dropdown-child");
            
        if (window.innerWidth <= 1023 && s) {
            t.preventDefault();
            
            // Close other open menus
            document
                .querySelectorAll(".site-nav-main--menu-lv-1.site-nav-main--item.dropdown.active")
                .forEach((t) => {
                    t !== e && t.classList.remove("active");
                });
                
            e.classList.toggle("active");
            
            let a = e.getAttribute("data-mobliemenu");
            if (a) {
                a = a
                    .toLowerCase()
                    .replace(/&/g, "")
                    .replace(/\s+/g, "-")
                    .replace(/[^\w-]/g, "");
                    
                const t = s.querySelector(".site-nav-main--menu-lv-2.dropdown-child");
                t && !t.classList.contains(a) && t.classList.add(a);
            }
            
            // Close other dropdowns
            document.querySelectorAll(".site-nav-main--menu.dropdown-child.open").forEach((t) => {
                t !== s && t.classList.remove("open");
            });
            
            s.classList.toggle("open");
        }
    }

    closeChild(t) {
        t.stopPropagation();
        const parent = t.target.parentElement;
        parent && parent.classList.remove("open");
    }
}

// Initialize only if mobile menu elements exist
document.addEventListener('DOMContentLoaded', function() {
    const mobileMenuItems = document.querySelectorAll(".site-nav-main--menu-lv-1.site-nav-main--item.dropdown");
    
    if (mobileMenuItems.length > 0) {
        const mobMenu = new MobileMenu();
    }
});
class MegaMenu {
    constructor() {
        this.menuList = document.querySelectorAll("[data-menulist]");
        this.menuGroup = document.querySelectorAll("[data-menugroup]");
        this.displayMain = document.querySelector(".site-nav-main--display");
        
        // Check if mega menu elements exist on this page
        if (!this.displayMain || this.menuList.length === 0) {
            return; // Exit if no mega menu found
        }

        this.grid = this.displayMain.querySelector(".site-nav-main--grid");
        
        if (!this.grid) {
            this.grid = document.createElement("ul");
            this.grid.classList.add("site-nav-main--grid");
            this.displayMain.appendChild(this.grid);
        }

        this.menuList.forEach((t) => {
            t.addEventListener("mouseenter", () => {
                this.setActive(t);
                this.updateDisplay(t);
            });
        });

        // Set initial active state if we have menu items
        if (this.menuList.length > 0) {
            this.setActive(this.menuList[0]);
            this.updateDisplay(this.menuList[0]);
        }
    }

    setActive(t) {
        this.menuList.forEach((item) => item.classList.remove("active"));
        t.classList.add("active");
    }

    updateDisplay(t) {
        const menuListValue = t.getAttribute("data-menulist");
        const menuGroup = Array.from(this.menuGroup).find(
            (item) => item.getAttribute("data-menugroup") === menuListValue
        );

        if (menuGroup) {
            const className = menuListValue
                .toLowerCase()
                .replace(/&/g, "")
                .replace(/\s+/g, "-")
                .replace(/[^\w-]/g, "");

            this.grid.className = "site-nav-main--grid";
            this.grid.classList.add(className);
            this.grid.innerHTML = menuGroup.innerHTML;
        } else {
            this.grid.innerHTML = "";
            this.grid.className = "site-nav-main--grid";
        }
    }
}

// Initialize only if we're on a page with mega menu
document.addEventListener('DOMContentLoaded', function() {
    const displayMain = document.querySelector(".site-nav-main--display");
    const menuList = document.querySelectorAll("[data-menulist]");
    
    if (displayMain && menuList.length > 0) {
        const megaMenu = new MegaMenu();
    }
});
class ToggleEvent {
    constructor() {
        (this.toggle = document.querySelectorAll(".toggle")), this.init();
    }
    init() {
        this.toggle.forEach((t) => {
            t.addEventListener("click", () => {
                const e = t.getAttribute("data-toggle"),
                    s = document.querySelector(`.${e}`);
                this.toggle.forEach((e) => {
                    if (e !== t) {
                        e.classList.remove("active");
                        const t = e.getAttribute("data-toggle"),
                            s = document.querySelector(`.${t}`);
                        s && (s.style.maxHeight = null);
                    }
                }),
                    t.classList.toggle("active"),
                    s && (s.style.maxHeight = t.classList.contains("active") ? s.scrollHeight + "px" : null);
            });
        });
    }
}
const toggle = new ToggleEvent();
class ScrollIndicator {
    constructor() {
        (this.blocks = document.querySelectorAll(".banner-main--block")),
            (this.indicators = document.querySelectorAll(".scroll-indicator__circle")),
            this.init();
    }
    init() {
        const t = new IntersectionObserver(
            (t) => {
                t.forEach((t) => {
                    t.isIntersecting && this.setActiveIndicator(Array.from(this.blocks).indexOf(t.target));
                });
            },
            { threshold: 0.5 }
        );
        this.blocks.forEach((e) => t.observe(e));
    }
    setActiveIndicator(t) {
        this.indicators.forEach((t) => t.classList.remove("active")), this.indicators[t].classList.add("active");
    }
}
const scroller = new ScrollIndicator();
class GlobalToggle {
    constructor() {
        (this.toggle = document.querySelectorAll(".toggler")), this.init();
    }
    init() {
        this.toggle.forEach((t) => {
            // Prevent duplicate listeners
            if (t.dataset.listener === 'true') return;
            t.dataset.listener = 'true';

            t.addEventListener("click", (event) => {
                event.preventDefault(); // Prevent any default link behavior if present
                const e = t.getAttribute("data-toggle"),
                    s = document.querySelector(`.${e}`);
                if (!s) return; // Exit if no target found

                // Close other toggles
                this.toggle.forEach((otherToggle) => {
                    if (otherToggle !== t) {
                        otherToggle.classList.remove("active");
                        const otherTargetClass = otherToggle.getAttribute("data-toggle");
                        const otherTarget = document.querySelector(`.${otherTargetClass}`);
                        if (otherTarget) {
                            otherTarget.style.maxHeight = null;
                            // Reset icon for other toggles (if FAQ style)
                            this.resetIcon(otherToggle);
                        }
                    }
                });

                // Toggle current
                t.classList.toggle("active");
                if (s.style.maxHeight) {
                    s.style.maxHeight = null;
                    this.resetIcon(t);
                } else {
                    s.style.maxHeight = s.scrollHeight + "px";
                    this.updateIcon(t);
                }
            });
        });
    }
    updateIcon(toggleEl) {
        const icon = toggleEl.querySelector('.icon-plus');
        if (icon) {
            icon.classList.add('active'); // Assumes CSS: .icon-plus.active { transform: rotate(45deg); }
            // Or swap to minus SVG if preferred: icon.classList.replace('icon-plus', 'icon-minus');
        }
    }
    resetIcon(toggleEl) {
        const icon = toggleEl.querySelector('.icon-plus');
        if (icon) {
            icon.classList.remove('active');
            // Or back to plus if swapped
        }
    }
}

// Initialize only after DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    const globalToggle = new GlobalToggle();
    window.globalToggle = globalToggle; // Global access if needed
});
class DeliveryCountdown {
    constructor() {
        (this.deliveryMessageElements = document.getElementsByClassName("countDownTimer")),
            (this.cutOffDays = this.parseCutOffDays()),
            this.updateTimer(),
            setInterval(() => this.updateTimer(), 1e3);
    }
    parseCutOffDays() {
        const t = document.querySelector(".countDownTimer");
        if (t) {
            const e = t.getAttribute("data-cutoffdays");
            if (e)
                return e.split(",").map((t) => {
                    const [e, s] = t
                        .trim()
                        .split(" - ")
                        .map((t) => t.trim());
                    return { date: e, time: s || null };
                });
        }
        return [];
    }
    formatDateUK(t) {
        return `${t.getDate().toString().padStart(2, "0")}/${(t.getMonth() + 1).toString().padStart(2, "0")}/${t.getFullYear().toString().slice(-2)}`;
    }
    getSpecialCutOffTime(t) {
        const e = this.formatDateUK(t),
            s = this.cutOffDays.find((t) => t.date === e);
        return s ? s.time : null;
    }
    isBlockedDayAfterCutoff(t, e) {
        const s = this.formatDateUK(t),
            a = this.cutOffDays.find((t) => t.date === s);
        if (!a) return !1;
        if (a.time) {
            const [s, r] = a.time.split(":").map(Number),
                i = new Date(t);
            return i.setHours(s, r, 0, 0), e > i;
        }
        return !0;
    }
    getTimeRemaining() {
        const t = new Date();
        let e = new Date(t);
        for (;;) {
            let s = this.getSpecialCutOffTime(e);
            const a = e.getDay();
            let r = new Date(e);
            if (s) {
                const [t, e] = s.split(":").map(Number);
                r.setHours(t, e, 0, 0);
            } else
                6 === a
                    ? r.setHours(14, 0, 0, 0)
                    : 0 === a
                      ? (r.setDate(r.getDate() + 1), r.setHours(18, 0, 0, 0))
                      : r.setHours(18, 0, 0, 0);
            if (t < r && !this.isBlockedDayAfterCutoff(e, t)) {
                const e = r - t;
                return {
                    hoursRemaining: Math.floor(e / 36e5),
                    minutesRemaining: Math.floor((e % 36e5) / 6e4),
                    secondsRemaining: Math.floor((e % 6e4) / 1e3),
                };
            }
            e.setDate(e.getDate() + 1);
        }
    }
    updateTimer() {
        const { hoursRemaining: t, minutesRemaining: e, secondsRemaining: s } = this.getTimeRemaining(),
            a = (t) => t.toString().padStart(2, "0");
        Array.from(this.deliveryMessageElements).forEach((r) => {
            r.textContent = `Same day dispatch ${a(t)}h ${a(e)}m ${a(s)}s`;
        });
    }
}
const countdown = new DeliveryCountdown();
class newsletterForm {
    constructor() {
        document.querySelector(".form-action--submit").addEventListener("click", async (t) => {
            this.submittedForm(), this.loadingSpinner(), t.preventDefault();
        });
    }
    loadingSpinner() {
        document.querySelector(".newsletter--button-container").classList.add("active");
    }
    submittedForm() {
        const t = document.getElementById("newsletterEmail").value,
            e = {
                method: "POST",
                headers: { revision: "2023-02-22", "content-type": "application/json" },
                body: JSON.stringify({
                    data: {
                        type: "subscription",
                        attributes: {
                            list_id: "XcJSLV",
                            custom_source: "Website Newsletter",
                            email: t,
                            properties: { newKey: "" },
                        },
                    },
                }),
            };
        fetch("https://a.klaviyo.com/client/subscriptions/?company_id=XYTG6S", e)
            .then((t) => {
                if (202 == t.status) {
                    setTimeout(() => {
                        document.querySelector(".newsletter--success").classList.remove("is-hidden"),
                            document.querySelector(".newsletter--input-wrapper").classList.add("success");
                    }, 800);
                } else {
                    setTimeout(() => {
                        document.querySelector(".newsletter--error").classList.remove("is-hidden"),
                            document.querySelector(".newsletter--button-container").classList.remove("active");
                    }, 500);
                }
            })
            .catch((t) => t);
    }
}
new newsletterForm();
class StickyHeader extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        (this.header = document.querySelector(".shopify-section-group-header-group")),
            (this.headerBounds = {}),
            (this.currentScrollTop = 0),
            (this.preventReveal = !1),
            (this.onScrollHandler = this.onScroll.bind(this)),
            (this.hideHeaderOnScrollUp = () => (this.preventReveal = !0)),
            this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp),
            window.addEventListener("scroll", this.onScrollHandler, !1),
            this.createObserver();
    }
    disconnectedCallback() {
        this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp),
            window.removeEventListener("scroll", this.onScrollHandler);
    }
    createObserver() {
        new IntersectionObserver((t, e) => {
            (this.headerBounds = t[0].intersectionRect), e.disconnect();
        }).observe(this.header);
    }
    onScroll() {
        const t = window.pageYOffset || document.documentElement.scrollTop;
        t > this.currentScrollTop && t > this.headerBounds.bottom
            ? requestAnimationFrame(this.hide.bind(this))
            : t < this.currentScrollTop && t > this.headerBounds.bottom
              ? this.preventReveal
                  ? (window.clearTimeout(this.isScrolling),
                    (this.isScrolling = setTimeout(() => {
                        this.preventReveal = !1;
                    }, 66)),
                    requestAnimationFrame(this.hide.bind(this)))
                  : requestAnimationFrame(this.reveal.bind(this))
              : t <= this.headerBounds.top && requestAnimationFrame(this.reset.bind(this)),
            (this.currentScrollTop = t);
    }
    hide() {
        this.header.classList.add("shopify-section-header-hidden", "shopify-section-header-sticky"),
            this.closeMenuDisclosure();
    }
    reveal() {
        this.header.classList.add("shopify-section-header-sticky", "animate"),
            this.header.classList.remove("shopify-section-header-hidden");
    }
    reset() {
        this.header.classList.remove("shopify-section-header-hidden", "shopify-section-header-sticky", "animate");
    }
    closeMenuDisclosure() {
        (this.disclosures = this.disclosures || this.header.querySelectorAll("details-disclosure")),
            this.disclosures.forEach((t) => t.close());
    }
}
customElements.define("sticky-header", StickyHeader);
